import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
  @Input() paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  @Input() isShowChangeRecordOfPage = true;
  // cho phep man host an dong "khong tim thay ban ghi nao" khi dang tai (skeleton)
  @Input() isShowNoRecord = true;

  @Output() changeTotalRecord = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<any>();

  constructor(
    public commonService: CommonService,
    private toastr: ToastrService,
    private translate: TranslateService
    ) { }

  checkFocus = true;
  // so trang nguoi dung nhap vao o "Di den" (mac dinh null)
  goToPage: number = null;

  /**
   * Danh sach muc hien thi cua day so trang: cua so 5 trang quanh trang hien tai,
   * luon kem trang dau + trang cuoi, dau '...' cho doan bi rut gon
   * (VD 12 trang, dang o trang 1: 1 2 3 4 5 ... 12)
   */
  get pageItems(): Array<number | string> {
    const paginate = this.paginate;
    const total = paginate ? paginate.totalPage : 0;
    const current = paginate ? paginate.currentPage : 0;
    if (!total || total < 1) {
      return [];
    }
    let start = Math.max(1, current + 1 - 2);
    let end = Math.min(total, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    const items: Array<number | string> = [];
    if (start > 1) {
      items.push(1);
      if (start > 2) {
        items.push('ellipsis-left');
      }
    }
    for (let p = start; p <= end; p++) {
      items.push(p);
    }
    if (end < total) {
      if (end < total - 1) {
        items.push('ellipsis-right');
      }
      items.push(total);
    }
    return items;
  }

  ngOnInit() {
    // this.paginate.pageSize = 10;
  }

  /**
   * On change pagination
   * @param event: Event
   * @param pageNo: number
   */
  onPageChange(event: Event, pageNo: number) {
    event.preventDefault();
    if (pageNo < 1 || pageNo > this.paginate.totalPage) {
      return;
    }
    this.pageChange.next({ page: pageNo - 1, pageSize: this.paginate.pageSize });
  }

  /**
   * On change total record per page
   */
  onChangeTotalRecord() {
    this.pageChange.next({ page: 0, pageSize: this.paginate.pageSize });
  }

  /**
   * Xu ly o "Di den": validate so trang nhap vao (goi khi nhan Enter hoac click icon chuyen trang)
   * - De trong: khong xu ly
   * - Khong phai so nguyen duong hoac ngoai pham vi 1..tong so trang: bao loi
   * - Hop le: chuyen den trang tuong ung
   */
  onGoToPage() {
    // de trong: khong xu ly
    if (this.goToPage === null || this.goToPage === undefined || ('' + this.goToPage).trim() === '') {
      return;
    }
    const page = Number(this.goToPage);
    // chi nhan so nguyen duong trong pham vi 1..tong so trang
    if (!Number.isInteger(page) || page < 1 || page > this.paginate.totalPage) {
      this.toastr.error(this.translate.instant('form.invalid_page_message'));
      return;
    }
    this.onPageChange(new Event('click'), page);
    this.goToPage = null;
  }

}
